"use client"

// src/oval.tsx
import { forwardRef } from "@yamada-ui/core";
import { Icon } from "@yamada-ui/icon";
import { jsx, jsxs } from "react/jsx-runtime";
var Oval = forwardRef(
  ({ color, duration = "1s", secondaryColor, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(Icon, { ref, stroke: color, viewBox: "0 0 38 38", ...rest, children: /* @__PURE__ */ jsx("g", { fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsxs("g", { strokeWidth: "2", transform: "translate(1 1)", children: [
      /* @__PURE__ */ jsx(
        "circle",
        {
          ...secondaryColor ? { stroke: secondaryColor } : { strokeOpacity: ".5" },
          cx: "18",
          cy: "18",
          r: "18"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M36 18c0-9.94-8.06-18-18-18", children: /* @__PURE__ */ jsx(
        "animateTransform",
        {
          type: "rotate",
          attributeName: "transform",
          dur: duration,
          from: "0 18 18",
          repeatCount: "indefinite",
          to: "360 18 18"
        }
      ) })
    ] }) }) });
  }
);
Oval.displayName = "Oval";
Oval.__ui__ = "Oval";

export {
  Oval
};
//# sourceMappingURL=chunk-RK3NNOXX.mjs.map